import { HabitSchedule } from 'shared/types/habit-schedule';

export const getActiveSchedule = (schedules?: HabitSchedule[] | null) =>
  schedules
    ?.filter(({ endDate }) => !endDate)
    .sort(
      (scheduleA, scheduleB) =>
        scheduleB.startDate.getTime() - scheduleA.startDate.getTime(),
    )[0];
